import { Map } from 'immutable';

import { ADD, ADD_MULTIPLE, UPDATE, REMOVE } from './constants';
import type Cause from './model';

export type CauseState = Map<string, Cause>;

const initialState: CauseState = Map();

export default (state = initialState, action): CauseState => {
  switch (action.type) {
    case ADD:
      return state.set(action.role.id, action.role);

    case ADD_MULTIPLE:
      return state.merge(action.roles);

    case UPDATE:
      return state.set(action.role.id, action.role);

    case REMOVE:
      return state.delete(action.id);

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
